import React from 'react';
import { Container } from 'react-bootstrap';

const NotFound: React.FC = () => {
  return <Container fluid>{'NOT FOUND'}</Container>;
};

export default NotFound;
